import React, {useRef, useState} from 'react';
import {Input, PageHeader, Space, Button} from 'antd';

import {PageGrid} from '@/component';
import {getColumns} from './lossColumns';
import {useAuthStore} from '@/context/auth';
import _ from 'lodash';
import styles from '../index.module.less';

export default function LossList() {
    const [authStore] = useAuthStore();
    const userId = _.get(authStore, 'user.extId');
    const tableRef = useRef();

    const [customerName, setCustomerName] = useState(null);
    const [userName, setUserName] = useState(null);

    function onCustomerNameChange({target: {value}}) {
        setCustomerName(value);
    }

    function onUserNameChange({target: {value}}) {
        setUserName(value);
    }

    function onSubmit() {
        const params = {
            customerName: customerName,
            userName: userName,
            userId,
        };
        tableRef.current.reload2FirstPage(params);
    }

    function onReset() {
        setCustomerName(null);
        setUserName(null);
        tableRef.current.reload2FirstPage({userId});
    }

    const columns = getColumns([
        'corpFullName',
        'corpName',
        'customerName',
        'customerType',
        'changeType',
        'userName',
        'timeStamp',
    ]);

    function renderExtra() {
        return (
            <Space>
                <Input
                    className={styles.baseSearch}
                    placeholder="客户名称"
                    value={customerName}
                    onChange={onCustomerNameChange}
                />
                <Input
                    className={styles.baseSearch}
                    placeholder="用户名称"
                    value={userName}
                    onChange={onUserNameChange}
                />
                <Button type="primary" onClick={onSubmit}>
                    搜索
                </Button>
                <Button onClick={onReset}>重置</Button>
            </Space>
        );
    }

    return (
        <div style={{flex: 'auto', flexDirection: 'row'}}>
            <PageHeader title="客户流失" extra={renderExtra()} />
            <div className={styles.tableContainer}>
                <PageGrid
                    url={'/customer/loss'}
                    ref={tableRef}
                    columns={columns}
                    initParams={{userId}}
                />
            </div>
        </div>
    );
}
